import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export function getTicketTransactionById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_REQUEST,
			payload: {
				loading: true
			}
		});

		let ticket;
		for (let i = 0; i < 10; i++) {
			await sleep(1500);

			const response = await API.ticket.getTicketById({ id });

			// something wrong
			if (response.meta.code !== 200) {
				dispatch(push('/payment/error'));
				return dispatch({
					type: ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_ERROR,
					payload: {
						meta: response.meta,
						loading: false
					}
				});
			}

			ticket = response.data.ticket;

			// handle paid case
			if (ticket.payment_status === 'paid') {
				dispatch({
					type: ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_SUCCESS,
					payload: {
						loading: false,
						ticket
					}
				});

				// DISPATCH AN ACTION TO LOAD TICKET TO TICKETS PAGE
				dispatch({
					type: ActionTypes.GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG,
					payload: {
						ticket
					}
				});

				dispatch(push('/tickets'));
				return;
			}

			// handle cancelled case
			if (ticket.payment_status === 'cancelled') {
				dispatch(push('/payment/error'));
				dispatch({
					type: ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_ERROR,
					payload: {
						loading: false,
						ticket
					}
				});

				// DISPATCH AN ACTION TO LOAD TICKET TO TICKETS PAGE
				dispatch({
					type: ActionTypes.GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG,
					payload: {
						ticket
					}
				});

				dispatch(push('/tickets'));
				return;
			}
		}
		dispatch(push('/tickets'));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_CB_JSUP_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_CB_JSUP_PAGE
		});
	};
}
